import { useEffect } from "react";

export const useMobileAppAuthCurrentState = (currentState, stateName, callback) => {
    useEffect(() => {
        if (currentState === stateName) {
            callback();
        }
    }, [callback, currentState, stateName]);
}
